import { createAsyncAction, ActionType } from 'typesafe-actions';
import { DataFetchingThunkAction } from '../types';
import { SuccessFetchActionPayload, FetchAction, DefaultErrorPayload } from '../dataFetching/generators';
import { getErrorCustomData } from '../../../common/errors/CustomFetchApiError';
import {
    URL_REDIRECT,
    UrlRedirectAction,
    RedirectResponse,
    UNSET_URL_REDIRECT,
    LandingPageRedirectsResponse,
} from './types';

export const isRedirected = (response: RedirectResponse): UrlRedirectAction => ({
    type: URL_REDIRECT,
    payload: response,
});

export const unsetRedirect = () => ({
    type: UNSET_URL_REDIRECT,
});

export const fetchLandingAndStylesRedirectsActions = createAsyncAction(
    '@REDIRECTS/LANDING_AND_STYLE/FETCH_START',
    '@REDIRECTS/LANDING_AND_STYLE/FETCH_SUCCESS',
    '@REDIRECTS/LANDING_AND_STYLE/FETCH_FAILED'
)<FetchAction, SuccessFetchActionPayload<LandingPageRedirectsResponse>, DefaultErrorPayload>();

export const fetchLandingAndStylesRedirectsIfNeeded = (hasQuery: boolean): DataFetchingThunkAction => async (
    dispatch,
    getState,
    { apiService, logger }
) => {
    if (
        !hasQuery ||
        getState().redirect.landingRedirectsIsFetching ||
        getState().redirect.landingRedirectsFetchingComplete
    ) {
        return;
    }
    dispatch(fetchLandingAndStylesRedirectsActions.request({ identifier: 'n/a' }));
    try {
        const landingRedirectsApiResponse = await apiService.shopApi.getLandingAndStyleRedirects();

        if (landingRedirectsApiResponse.success) {
            dispatch(
                fetchLandingAndStylesRedirectsActions.success({ data: landingRedirectsApiResponse, identifier: 'n/a' })
            );
        } else {
            throw new Error('landingRedirectsApiResponse not success / empty');
        }
    } catch (err) {
        logger.error(err, { action: 'fetchLandingAndStylesRedirectsIfNeeded', ...getErrorCustomData(err) });
        dispatch(fetchLandingAndStylesRedirectsActions.failure({ error: err, identifier: 'n/a' }));
    }
};

export type LandingAndStylesRedirectsActionsType = ActionType<typeof fetchLandingAndStylesRedirectsActions>;
